import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/toPromise';

import { Configuration } from '../../config/environment';
import { DefinoInputRentenTool, TeaserPostModel, TeaserResponseModel } from './teaser.model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable()
export class AbstractWS {

    constructor(private httpClient: HttpClient) { }

    private addAuthHeaders(headers: HttpHeaders, auth: string): void {
        let token = auth;
        if (token) {
            headers.append('x-auth', token);
        }
        //headers.append('x-appid', Configuration.apiName);
    }

    private getHeaders(auth: string): HttpHeaders {
        let headers = new HttpHeaders();
        headers.append('Accept', 'application/json');
        this.addAuthHeaders(headers, auth);
        return headers;
    }

    protected makeGetRequest(path: string, auth: string): Promise<any> {
        let fullUrl = path;

        return new Promise((resolve, reject) => {
            this.httpClient.get(fullUrl, { headers: this.getHeaders(auth) }).subscribe(response => {
                resolve(response);
            }, err => {
                console.error(err);
                reject(null);
            });
        });
    }

    protected makePostRequest(url: string, inputData: any, auth: string): Promise<any> {
        let headers = this.getHeaders(auth).set('Content-Type', 'application/json');
        let body = JSON.stringify(inputData);

        return this.httpClient.post(url, body, { headers: headers })
            .toPromise()
            .then((response: HttpResponse<any>) => {
                return Promise.resolve(response);
            }).catch(function (error) {
                return Promise.reject(error);
            });
    }

    protected makePostRequestFormData(url: string, formData: FormData, auth: string): Promise<any> {
        let headers = this.getHeaders(auth);
        return this.httpClient.post(url, formData, { headers: headers })
            .toPromise()
            .then((response: HttpResponse<any>) => {
                return Promise.resolve(response);
            }).catch(function (error) {
                return Promise.reject(error);
            });
    }

    protected makePostMultipartRequest(url: string, formData: FormData, auth: string) {
        let headers = new HttpHeaders({ 'x-appid': Configuration.apiName });
        return this.httpClient.post(url, formData, { headers: headers });
    }

    protected makeGenericGet(url: string): string {
        return [url, 'apiName=' + Configuration.apiName].join('?');
    }

    public getCalculations(values: any): Promise<any> {
        return this.makePostRequest(Configuration.urlWithServiceRechner, values, null).then((response: any) => {
            return Promise.resolve(response);
        }).catch(function (error) {
            return Promise.reject(null);
        });
    }

    public getMapInputAndDefinoInput(input: any, definoInput: DefinoInputRentenTool): Promise<any> {
        let data: FormData = new FormData();
        data.append("input", JSON.stringify(input));
        data.append("definoInput", JSON.stringify(definoInput));
        return this.makePostRequestFormData(Configuration.urlWithApiGen + "mapInputDefino", data, null).then((response: any) => {
            return Promise.resolve(response);
        }).catch(function (error) {
            return Promise.reject(null);
        });
    }


    public getPDFFile(input: TeaserPostModel, output: TeaserResponseModel) {
        let formData: FormData = new FormData();
        formData.append("input", JSON.stringify(input));
        formData.append("output", JSON.stringify(output));

        this.httpClient.post(Configuration.url + Configuration.apiGen + "generateContentPDFFile", formData).toPromise().then((response: any) => {
            window.open(this.makeGenericGet(Configuration.url + Configuration.apiGen + 'getGeneratedPdf/' + response.uuid), '_system');
        }).catch((error) => {
            console.error(error);
        });
    }
}

export class ParamRequest {
    key: string;
    value: string;

    constructor(k: string, v: string) {
        this.key = k;
        this.value = v;
    }
}



// WEBPACK FOOTER //
// ./src/components/teaser/teaser.service.ts